import { Turret } from "../Turret";
import { Engine } from "../../Engine";
import { MathUtils } from "../../utils/MathUtils";
import { GameConstants } from "../../GameConstants";
import { Enemy } from "../../enemies/Enemy";

export class Mine {

    public id: number;
    public x: number;
    public y: number;
    public explosionRange: number;
    public range: number;
    public damage: number;
    public detonate: boolean;
    public turret: Turret;

    public f: number;
    public moveTime: number;

    private engine: Engine;

    constructor (p: {r: number, c: number}, explosionRange: number, damage: number, turret: Turret, engine: Engine) {
        
        this.id = engine.mineId;
        engine.mineId ++;

        this.x = p.c + .5;
        this.y = p.r + .5;

        this.explosionRange = explosionRange;
        this.damage = damage;
        this.range = .25;
        this.detonate = false;
        this.engine = engine;

        this.turret = turret;

        this.moveTime = 40;
        this.f = 0;
    }

    public destroy(): void {
        // nada de momento
    }

    public update(): void {

        if (this.f < this.moveTime) {
            this.f++;
            return;
        }

        if (this.f === this.moveTime) {
            this.f++;
        }
        
        if (!this.detonate) {

            for (let i = 0; i < this.engine.enemies.length; i ++) {

                const enemy = this.engine.enemies[i];
                const distance = MathUtils.fixNumber(Math.sqrt((enemy.x - this.x) *  (enemy.x - this.x) + (enemy.y - this.y) *  (enemy.y - this.y)));

                if (enemy.type === GameConstants.ENEMY_WIND) {
                    continue;
                }

                if (distance <= this.range) {
                    this.detonate = true;
                    break;
                }
            }
        }
    }

    public getEnemiesWithinExplosionRange(): {enemy: Enemy, damage: number} [] {

        const hitEnemiesData: {enemy: Enemy, damage: number} [] = [];

        for (let i = 0; i < this.engine.enemies.length; i ++) {

            const enemy = this.engine.enemies[i];
            const distance = MathUtils.fixNumber(Math.sqrt((enemy.x - this.x) *  (enemy.x - this.x) + (enemy.y - this.y) *  (enemy.y - this.y)));

            if (distance <= this.explosionRange) {

                const damage = MathUtils.fixNumber(this.damage * (1 - distance / this.explosionRange));
                hitEnemiesData.push({enemy: enemy, damage: damage});
            }
        }

        return hitEnemiesData;
    }
}
